const data = [
  {
    name: "15th International Conference on Greek Linguistics",
    url: "http://icgl15.fil.bg.ac.rs/",
    imageUrl: "icgl15.png",
    description:
      "Multilingual (English/Greek) website built with Gatsby and React for the 15th International Conference on Greek Linguistics hosted by The Department of Modern Greek Studies, Faculty of Philology, University of Belgrade.",
    tags: ["frontend", "personal", "React", "Gatsby", "JavaScript", "GraphQL"],
  },
  {
    name: "Cincinnati Playhouse in the Park",
    url: "http://cincyplay.com/",
    imageUrl: "cinci.jpg",
    description:
      "Nestled on a hill and commanding a superb view of downtown Cincinnati, Cincinnati Playhouse in the Park has been offering audiences the finest in professional theatre.",
    tags: [
      "backend",
      "frontend",
      "team",
      "Sitefinity",
      "C#",
      "SQL",
      "Angular",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    name: "Milos Popovic",
    url: "https://milospopovic.net/",
    imageUrl: "milos.png",
    description:
      "Milos Popovic is a Data Analyst at Booking.com in Amsterdam. His research explores how countries intervene in civil wars abroad. He uses R to create maps that make sense of big data. According to NodeXL, he is a Top 10 dataviz and R contributor on Twitter",
    tags: ["frontend", "personal", "React", "Gatsby", "JavaScript", "GraphQL"],
  },
  {
    name: "Omaha Performing Arts",
    url: "https://omahaperformingarts.org/",
    imageUrl: "opa.png",
    description:
      "Omaha Performing Arts is dedicated to creating a vibrant arts and entertainment experience in Omaha and the region. Since its inception, Omaha Performing Arts has grown to become the largest arts institution in Nebraska.",
    tags: [
      "frontend",
      "Sitefinity",
      "team",
      "Angular",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    name: "Thanksgiving Point",
    url: "http://thanksgivingpoint.org/",
    imageUrl: "tgp.png",
    description:
      "Thanksgiving Point Institute is a nonprofit farm, garden, and museum complex that draws upon the natural world to cultivate transformative family learning.",
    tags: [
      "backend",
      "frontend",
      "Umbraco",
      "team",
      "C#",
      "SQL",
      "Angular",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    name: "Laguna Playhouse",
    url: "https://www.lagunaplayhouse.com/",
    imageUrl: "laguna.png",
    description:
      "Laguna Playhouse is a historic Equity theatre located in the charming arts colony of Laguna Beach, California. Steps away from the Pacific Ocean, Laguna Playhouse is known for its year-round season of captivating comedies, dramas, musicals, stand-up comedy and family fare.",
    tags: [
      "backend",
      "frontend",
      "team",
      "Umbraco",
      "C#",
      "SQL",
      "Angular",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    name: "Aleksandar Popovic",
    url: "https://aleksandarpopovic.com/",
    imageUrl: "landing.png",
    description:
      "It's very meta, I know. I needed a place where I could put all of my projects - so I made one. This is the second version of my personal website and it's built on top of Gatsby. I wanted to build something practical in React and I wanted to start writing a blog, so Gatsby seemed like a perfect fit.",
    tags: ["frontend", "personal", "React", "Gatsby", "JavaScript", "GraphQL"],
  },
  {
    name: "Covid19 Historical Data",
    url: "https://aleksandarpopovic.com/covid19",
    imageUrl: "dashboard.png",
    description:
      "Covid-19 Historical Data is a simple dashboard for tracking and comparing historical data for Covid-19 virus. All country data is being fetched via NovelCOVID API. All news, emergencies and outbreaks data is being fetched via World Health Organization's official website and WHO's rss feed.",
    tags: ["frontend", "personal", "HTML", "CSS", "JavaScript", "Chartist"],
  },
]

export default data
